<template>
  <div class="nx-signing-modal-method">
    <h4>{{ $t('ChooseSignMethod') }}</h4>
    <h5 class="mt-4">
      {{ $t('PleaseChooseSignMethod') }}
    </h5>

    <b-container class="mt-4">
      <b-row align-h="center">
        <b-col cols="6">
          <b-list-group>
            <b-list-group-item
              v-if="!isMobileOrSafari()"
              button
              @click="P12orToken('SIGN_P12')"
            >
              {{ $t('P12Sign') }}
            </b-list-group-item>
            <b-list-group-item
            v-if="!isMobileOrSafari()"
            button
            @click="P12orToken('SIGN_TOKEN')"
          >
            {{ $t('TokenSign') }}
          </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { IAMSmartSigningPlainButton, IAMSmartLink } from '@nextore/iam-smart';
import { SignApi } from '@/api';

export default {
  props: {
    value: {}
  },
  components: {
    IAMSmartSigningPlainButton,
    IAMSmartLink
  },
  methods: {
    isMobileOrSafari() {
      let ua = navigator.userAgent;

      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = ipad || isIphone || isAndroid;

        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        console.log("isMobile", isMobile);
        console.log("isSafari", isSafari);


      return (isMobile||isSafari);
    },
    next(signMethod) {
      console.log('next');
      this.$emit('input', {
        ...this.value,
        signMethod
      });
      this.$emit('next');
    },
    async P12orToken(signMethod) {
      try {
        this.next(signMethod);
      } catch (ex) {
        if (ex.response) {
          this.$emit('input', ex.response.data);
          this.$emit('fail');
        } else {
          throw ex;
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        ChooseSignMethod: 'Choose a sign method',
        PleaseChooseSignMethod:
          'Please choose one of the following method to sign',
        P12Sign: 'Sign with Digital Certificate File',
        TokenSign: 'Sign with Digital Certificate Token',
        IAmSmartSign: 'Sign with "iAM Smart"'
      },
      zh_hk: {
        ChooseSignMethod: '選擇簽署方式',
        PleaseChooseSignMethod: '請選擇以下一種方式簽署文件',
        P12Sign: '用數碼證書檔案簽署',
        TokenSign: '用數碼證書Token簽署',
        IAmSmartSign: '用「智方便」簽署'
      },
      zh_cn: {
        ChooseSignMethod: '选择签署方式',
        PleaseChooseSignMethod: '请选择以下一种方式签署文件',
        P12Sign: '用数码证书档案签署',
        TokenSign: '用数码证书Token签署',
        IAmSmartSign: '用「智方便」签署'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method {
  text-align: center;
}
</style>
